import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { StateService } from '../../../services/state.service';
import { VehicleDetailsService } from '../../../services/vehicle-details.service';
import { BehaviorSubject } from 'rxjs';
import { FormInfoService } from '../../../services/form-info.service';
@Component({
    selector: 'an-fav-tile-result',
    templateUrl: './fav-tile-result.component.html',
    styleUrls: ['./fav-tile-result.component.scss'],
    standalone: false
})


export class FavTileResultComponent implements OnInit {
  vehicles = [];
  showBanner = true;
  inStockVehicles: any[];
  constructor(
    private _vehicleDetails: VehicleDetailsService,
    private _stateData: StateService,
    private _formInfo: FormInfoService,
  ) {
    this.innerWidth = window.innerWidth;
  }
  loadEmptyTile: boolean = true;
  innerWidth: any;
  stateData: any;
  isInstigator: boolean;
  isFav: boolean;
  isAnyVehicleGone: boolean;
  ngOnInit() {

    this.callVehicleDetails();
  }

  callVehicleDetails(): any {
    this.stateData = this._stateData?.state?.Sitecore?.labels || null;
    this._stateData.showBannerComp.subscribe((item) => {
      this.showBanner = item;
    });
    this._vehicleDetails.getVehicleDetails().subscribe(
      response => {
        response.Vehicles.forEach((item: any, index: number) => {
          item['index'] = index
        });
        this._vehicleDetails.favVehicleDetails.next(response.Vehicles);
        this._vehicleDetails.favVehicleDetails.subscribe(val => {
          this.vehicles = val.filter((item => item.isValidVin && item.inventoryStatus !== 'G'));
          this.loadEmptyTile = false;
          this.isInstigator = true;
          this.isFav = true;
          const inValidVin = val.filter((item => item.isValidVin === false));
          this.inStockVehicles = val.filter(x => x.inventoryStatus !== 'G' &&  x.isValidVin);
          this.isAnyVehicleGone = val.filter(x => x.inventoryStatus === 'G' || !x.isValidVin).length > 0;
          const zipCode = this._stateData?.state?.Sitecore?.LeadInformation.ZipCode;
          this._formInfo.pageLoad(this.vehicles, zipCode);
        });

      },
      error => {
        this._vehicleDetails.favVehicleDetails.next([]);
        this._vehicleDetails.favVehicleDetails.subscribe(val => {
          this.vehicles = val.filter((item => item.isValidVin));
          this.loadEmptyTile = false;
          this.isInstigator = true;
          this.isFav = true;
          this.inStockVehicles = this.vehicles.filter(x => x.inventoryStatus !== 'G');
          this.isAnyVehicleGone = this.vehicles.filter(x => x.inventoryStatus === 'G').length > 0;
        });
      }
    )
  }

  emptyTilesCount(): any {
    if (this.innerWidth <= 575) {
      return [1, 2, 3];
    }
    if (this.innerWidth >= 576 && this.innerWidth <= 991) {
      return [1, 2, 3, 4];
    }
    else if (this.innerWidth >= 992 && this.innerWidth <= 1120) {
      return [1, 2];
    }
    else if (this.innerWidth >= 1121) {
      return [1, 2, 3, 4, 5, 6];
    }
  }

}
